<template>
  <div class="agreement" v-html="$t('agreementText')">
  </div>
</template>

<script>
export default {
  name: "AgreeTermsAndPolitics",
  i18n: {
    messages: {
      en: {
        agreementText: 'By clicking the Register button,' +
            '<br> you agree to the' +
            '<br><a class="text-text-label hover:text-red duration-200 transition" href="/en/legal/agreement" target="_blank">Terms of Service</a> and ' +
            '<a class="text-text-label hover:text-red duration-200 transition" href="/en/legal/privacy-policy" target="_blank">Privacy Policy</a>.'
      },
      ru: {
        agreementText: 'Нажимая кнопку “Зарегистрироваться”, ' +
            '<br>вы соглашаетесь с условиями ' +
            '<a class="text-text-label hover:text-red duration-200 transition" href="/ru/legal/agreement" target="_blank">Пользовательского соглашения</a> и ' +
            '<a class="text-text-label hover:text-red duration-200 transition" href="/ru/legal/privacy-policy" target="_blank">Политики конфиденциальности.</a>'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.agreement {
  @apply text-center text-xs text-text-ternary mb-2;
}
</style>
